import { toInvoiceStatusBadgeProps, toMoney } from '@sequencehq/utils'
import {
  Text,
  Badge,
  CustomerLogo,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  Primary12Regular,
  Primary13SemiBold,
  Section,
  Flex
} from '@sequencehq/core-components'
import { Invoice } from 'Invoices/types'
import { getHumanReadableInvoiceNumber } from 'Invoices/utils'
import { getLogoSrc, useFetchCustomerQuery } from 'Customer/index'

export const InvoiceSection = ({ invoice }: { invoice: Invoice }) => {
  const { customerDetails: customer } = useFetchCustomerQuery(
    invoice.customerId
  )
  const logoSrc = customer ? getLogoSrc(customer) : undefined

  const invoiceNumber = getHumanReadableInvoiceNumber({
    invoiceNumber: invoice.invoiceNumber,
    invoiceStatus: invoice.status
  })
  const grossTotal = toMoney({
    currency: invoice.currency,
    value: invoice.grossTotal
  })

  // marginBottom is reset to 0 because the parent owns inter-section spacing.
  return (
    <Section title="Invoice" marginBottom={0}>
      <Flex
        gap="12px"
        padding="12px"
        border={`1px solid ${GreyGrey30}`}
        borderRadius="8px"
        alignItems="center"
      >
        <CustomerLogo src={logoSrc} size={32} />
        <Flex flexDir="column" flex="1" minWidth="0">
          <Text {...Primary13SemiBold} color={GreyGrey80}>
            {customer?.legalName ?? ''}
          </Text>
          <Text {...Primary12Regular} color={GreyGrey60}>
            {invoiceNumber}
          </Text>
        </Flex>
        <Flex alignItems="center" gap="8px">
          <Text {...Primary13SemiBold} color={GreyGrey80}>
            {grossTotal}
          </Text>
          <Badge
            {...toInvoiceStatusBadgeProps({
              status: invoice.status,
              size: 'sm'
            })}
          />
        </Flex>
      </Flex>
    </Section>
  )
}
